import { z } from "zod";
import i18n from "@/i18n";

const t = (key: string) => i18n.t(key, { ns: "validation" });

export const petApplicationPlanSchema = z.object({
  pet_id: z.string().uuid(t("selectPatient")),
  clinic_id: z.string().uuid(t("clinicRequired")),
  item_id: z.preprocess(
    (value) => (value === "" ? null : value),
    z.string().uuid().nullable(),
  ),
  due_date: z.date({ required_error: t("applicationDateRequired") }),
  notes: z.string().optional().nullable().or(z.literal("")),
  appointment_id: z.preprocess(
    (value) => (value === "" ? null : value),
    z.string().uuid().optional().nullable(),
  ),
  next_applications: z.array(
    z.object({
      _key: z.string(),
      item_id: z.string().uuid().nullable(),
      item_label: z.string(),
      interval_days: z.number().nullable(),
      due_date: z.date().nullable(),
    })
  ).optional().default([]),
}).refine(
  (data) => data.item_id,
  {
    message: t("vaccineRequired"),
    path: ["item_id"],
  },
);

export type PetApplicationPlanInput = z.infer<typeof petApplicationPlanSchema>;
